import React, { useState, useEffect } from 'react';
import axios from 'axios';
import AdSense from 'react-adsense';
import { useNavigate, NavLink, useParams } from "react-router-dom";
import { alert_error, alert_success } from '../../../AppContext';
import { Cookies } from '../../../index.js';
import History from "./history";
import { ClipLoader } from "react-spinners";
const InviteFriends = () => {
  const [nutxuly, setnutxuly] = useState(0);
  const [nutorder, setnutorder] = useState('✔️ Click to Confirm');
  const { slug_2 } = useParams();
  const [money, setmoney] = useState('');
  const [link_ref, setlink_ref] = useState('');
  const laythongtin = (apikey, service) => {
    axios
      .get('https://hust.media/link/load_users/get_info.php', {
        params: {
            apikey: apikey,
            service: service
        }
      })
      .then(response =>
        testFunction4(response, service)
      )
      .catch(error => console.log(123 + error));
  };
  const testFunction4 = (response, service) => {
    console.log(response);
    const info = response.data;
    if (info.money) {
      setmoney(info.money);
    }
  };
  const laydulieu = () => {
    const apiKey = Cookies.get('apikey');
    if (apiKey !== null) {
      // Có API key, thực hiện các hành động cần thiết
      laythongtin(apiKey, 'getmoney');
    } else {
      // Không có API key, thực hiện các hành động khác (ví dụ: yêu cầu người dùng nhập API key)
      console.log('Không có API key.');
    }
  };
  useEffect(() => {
    // Kiểm tra xem có giá trị "apikey" trong AsyncStorage không
    laydulieu();
  }, []);
  function saochep(value) {
    alert_success('Đã sao chép');
    window.saochepnative(value);
  };
  function handleSubmit(event) {
    setnutxuly(0);
    const apikey = Cookies.get('apikey');
    event.preventDefault();

    setnutxuly(1);
    setnutorder('Please wait a moment 😊');
    if (!apikey) {
      alert_error('Please điền đầy đủ thông tin')
      setnutxuly(0);
      setnutorder('điền đủ thông tin');
      return
    }
    axios
      .post('https://hust.media/link/load_users/pay.php', {
        apikey: apikey
      })
      .then(
        response => (testFunction(response))
      )
      .catch(error => console.log(error))

  };
  function testFunction(response) {
    const info = response.data;
    const status = info.status;
    const message = info.message;
    setnutorder('đặt tiếp luôn nào')
    setnutxuly(0);
    if (status == 0) {
      alert_error(info.message);
    }
    else if (status == 1) {
      alert_success(info.message);
    }
    if (info.redirect != null && info.redirect != '') {
      setTimeout(function () {
        // Chuyển hướng sang trang web khác
        window.location.href = info.redirect;
      }, 1700);
    }
  };
  return (
    <div className="mt-2 mx-2">
      {!money ? (<>
        <div style={{ textAlign: "center" }} className="mt-4 justify-center items-center">
          <ClipLoader size={90} color="#8a2be2" />
        </div>
      </>) : (<>
        <div className="max-w-xl mt-2 mx-2 mx-auto">
          <div className="bg-white p-2 rounded-md shadow-md ">
            <div className="bg-gray-100 rounded-md shadow-md border-1 border-purple-300">
              <div className="text-base mt-2 text-center font-semibold">Số dư sáng tạo :</div>
              <div className="mb-2 text-center text-lg text-purple-700">{money} Coins</div>
            </div>
          </div>
          <form className="mt-2 mb-1 add-form">
            <div className="form-control">
              <div className="mx-2">
                <label className="mt-1 text-base">Để nhận được Coins sáng tạo bạn cần chuyển số
                  dư sáng tạo qua số dư chính. Đk: Tối thiểu 4k Coins, ít nhất 10 người ấn link. Ấn rút khi chưa đủ điều kiện sẽ trừ 100 Coins
                </label>
                <button disabled={nutxuly == 1}
                  onClick={handleSubmit}
                  className='mt-3 flex break-inside bg-purple-400 hover:bg-purple-300 rounded-3xl px-8 py-2 mb-2 w-full dark:bg-slate-800 dark:text-white'>
                  <div className='flex items-center justify-between flex-1'>
                    {nutxuly == 1 &&
                      <div className="spinner-border" role="status">
                      </div>}
                    <span className='text-lg font-medium text-white'>
                      {nutorder} </span>
                      <div className="text-xl">
                                        {'\u27A4'}
                                    </div>
                  </div>
                </button>
              </div>
            </div>
          </form>
          <div className="cards">
            <AdSense.Google
              client="ca-pub-4574266110812955"
              slot="3259681051"
              style={{ display: 'block' }}
              format="auto"
              responsive="true"
            /></div>
        </div>
      </>)}
    </div>
  );
};

export default InviteFriends;
